module.exports = __webpack_public_path__ + "static/media/valves.05c6e24f.png";